/**
 * @generated SignedSource<<c469e45ffaeaa6349857c710fc20543e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type DevOpsPullRequestStatus = "DECLINED" | "DRAFT" | "MERGED" | "OPEN" | "UNKNOWN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type statusFilter_softwareCodePage$data = ReadonlyArray<{
  readonly status: DevOpsPullRequestStatus | null | undefined;
  readonly " $fragmentType": "statusFilter_softwareCodePage";
}>;
export type statusFilter_softwareCodePage$key = ReadonlyArray<{
  readonly " $data"?: statusFilter_softwareCodePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"statusFilter_softwareCodePage">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "statusFilter_softwareCodePage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ],
  "type": "DevOpsPullRequestDetails"
};

(node as any).hash = "d32466766a25effcd92bd6d8743c3804";

export default node;
